import React from 'react';
import {Button, ButtonPriority, ButtonSize, Dialog, Text, TextTypography} from '@wix/wix-ui-tpa/cssVars';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {classes} from './RemoveLinkedItemsDialog.st.css';

export enum RemoveLinkedItemsDialogDataHook {
  Root = 'RemoveLinkedItemsDialog.dialog',
  Title = 'RemoveLinkedItemsDialog.title',
  Description = 'RemoveLinkedItemsDialog.description',
  CancelButton = 'RemoveLinkedItemsDialog.cancelButton',
  RemoveButton = 'RemoveLinkedItemsDialog.removeButton',
}

export interface RemoveLinkedItemsDialogProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const RemoveLinkedItemsDialog = ({onConfirm, onCancel}: RemoveLinkedItemsDialogProps) => {
  const {t} = useTranslation();

  return (
    <Dialog data-hook={RemoveLinkedItemsDialogDataHook.Root} isOpen onClose={onCancel}>
      <div className={classes.root}>
        <Text typography={TextTypography.largeTitle} data-hook={RemoveLinkedItemsDialogDataHook.Title}>
          {t('cart.removePlanItemModal.title')}
        </Text>
        <div className={classes.dialogTextContent}>
          <Text data-hook={RemoveLinkedItemsDialogDataHook.Description}>
            {t('cart.removePlanItemModal.description')}
          </Text>
        </div>
        <Button
          data-hook={RemoveLinkedItemsDialogDataHook.CancelButton}
          priority={ButtonPriority.basicSecondary}
          className={classes.dialogButton}
          onClick={onCancel}>
          {t('cart.removePlanItemModal.cancelButton')}
        </Button>
        <Button
          data-hook={RemoveLinkedItemsDialogDataHook.RemoveButton}
          size={ButtonSize.medium}
          className={classes.dialogButton}
          onClick={onConfirm}>
          {t('cart.removePlanItemModal.removeButton')}
        </Button>
      </div>
    </Dialog>
  );
};
